import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '../../../dtos/user';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {NotificationService} from '../../../services/common/notification.service';

export interface DialogData{
  user: User;
}

@Component({
    selector: 'app-manage-user',
    templateUrl: './manage-user.component.html',
    styleUrls: ['./manage-user.component.scss'],
    standalone: false
})
export class ManageUserComponent implements OnInit {

  user: User;
  roleFormGroup: UntypedFormGroup;
  roleList = ['Admin', 'Premium', 'Standard'];

  constructor(private notificationService: NotificationService,
              private _formBuilder: UntypedFormBuilder,
              @Inject(MAT_DIALOG_DATA) public injectedData:DialogData,
              private dialogRef: MatDialogRef<ManageUserComponent>
  ) {
    this.user = injectedData.user;
  }

  ngOnInit(): void {
    this.roleFormGroup = this._formBuilder.group({
      roleInput: new UntypedFormControl(this.getRoleListEntry(this.user.role))
    });
  }

  getRoleListEntry(role: string) {
    switch (role) {
      case 'ROLE_ADMIN':
        return this.roleList[0];
      case 'ROLE_USER_FREE':
        return this.roleList[2];
      case 'ROLE_USER_PAID':
        return this.roleList[1];
    }
  }

  updateUserRole() {
    if (!this.transformRoleName(this.roleFormGroup.controls.roleInput?.value)) {
      this.notificationService.openSnackBar('Keine Rolle ausgewählt!');
      this.dialogRef.close(null);
    } else {
      this.user.role = this.transformRoleName(this.roleFormGroup.controls.roleInput?.value);
      this.dialogRef.close(this.user);
    }
  }

  transformRoleName(role: string) {
    switch (role) {
      case 'Admin':
        return 'ROLE_ADMIN';
      case 'Standard':
        return 'ROLE_USER_FREE';
      case 'Premium':
        return 'ROLE_USER_PAID';
    }
  }

}
